import React from 'react';
import { Link } from 'react-router-dom';
import { FiChevronRight, FiMapPin, FiMail, FiPhone } from 'react-icons/fi';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaYoutube } from 'react-icons/fa';
import logo from '../assest/company logo.png';

export default function Footer() {
  return (
    <footer className="px-6 pb-6 pt-14 text-white sm:px-10 lg:px-16" style={{ backgroundColor: '#141414' }}>
      <div className="mx-auto max-w-7xl">
        {/* ============ LOGO / ABOUT — COMPANY — SUPPORT — CONNECT WITH US ============ */}
        <div className="grid grid-cols-1 gap-10 pb-10 sm:grid-cols-2 lg:grid-cols-4">
          {/* Logo + About */}
          <div>
            <div className="flex items-center gap-3">
              <img src={logo} alt="Prithviraj Corporation Limited" className="h-14 w-14 object-contain" />
              <div>
                <p className="text-xl font-extrabold uppercase leading-none tracking-tight">Prithviraj</p>
                <p className="mt-1 text-xs font-semibold uppercase tracking-[0.15em] text-brand-orange">
                  Corporation Limited
                </p>
              </div>
            </div>

            <p className="mt-4 text-sm leading-relaxed text-white/50">
            ISO-certified manufacturing and trading company providing high-quality transformers, poles, 
            conductors, insulators, and electrical infrastructure solutions for reliable power transmission and distribution.
            </p>

            <div className="mt-6 flex items-center gap-3">
              <button
                type="button"
                className="flex h-8 w-8 items-center justify-center rounded-full bg-brand-orange transition hover:brightness-110"
                aria-label="Facebook"
              >
                <FaFacebookF size={13} />
              </button>
              <button
                type="button"
                className="flex h-8 w-8 items-center justify-center rounded-full bg-brand-orange transition hover:brightness-110"
                aria-label="Twitter / X"
              >
                <FaTwitter size={13} />
              </button>
              <button
                type="button"
                className="flex h-8 w-8 items-center justify-center rounded-full bg-brand-orange transition hover:brightness-110"
                aria-label="LinkedIn"
              >
                <FaLinkedinIn size={13} />
              </button>
              <button
                type="button"
                className="flex h-8 w-8 items-center justify-center rounded-full bg-brand-orange transition hover:brightness-110"
                aria-label="YouTube"
              >
                <FaYoutube size={13} />
              </button>
            </div>
          </div>

          {/* Company */}
          <div>
            <p className="mb-4 text-base font-bold">Company</p>
            <div className="space-y-2.5 text-sm text-white/60">
              <Link to="/about" className="flex items-center gap-1.5 transition hover:text-white">
                <FiChevronRight className="text-brand-orange" size={14} /> About Us
              </Link>
              
             
              
              
            </div>
          </div>

          {/* Support */}
          <div>
            <p className="mb-4 text-base font-bold">Support</p>
            <div className="space-y-2.5 text-sm text-white/60">
              <a href="mailto:info@prithvirajlimited.com" className="flex items-center gap-1.5 transition hover:text-white">
                <FiChevronRight className="text-brand-orange" size={14} /> Email Us
              </a>
              
              <Link to="/services/trading" className="flex items-center gap-1.5 transition hover:text-white">
                <FiChevronRight className="text-brand-orange" size={14} /> Trading
              </Link>
              <Link to="/services/manufacturing" className="flex items-center gap-1.5 transition hover:text-white">
                <FiChevronRight className="text-brand-orange" size={14} /> Services
              </Link>
              <Link to="/products" className="flex items-center gap-1.5 transition hover:text-white">
                <FiChevronRight className="text-brand-orange" size={14} /> Products
              </Link>
            </div>
          </div>

          {/* Connect With Us */}
          <div>
            <p className="mb-4 text-base font-bold">Connect With Us</p>
            <div className="space-y-3.5 text-sm text-white/60">
              <div className="flex items-start gap-2.5">
                <FiMapPin className="mt-0.5 shrink-0 text-brand-orange" size={16} />
                <span>
                  Unit No 930B, 9th Floor, Tower B, Spaze I Tech Park,
                  Sector-49, Sohna Road, Gurugram (HR) - 122018
                </span>
              </div>
              <a href="mailto:info@prithvirajlimited.com" className="flex items-center gap-2.5 transition hover:text-white">
                <FiMail className="shrink-0 text-brand-orange" size={16} />
                info@prithvirajlimited.com
              </a>
              <a href="tel:+919958260035" className="flex items-center gap-2.5 transition hover:text-white">
                <FiPhone className="shrink-0 text-brand-orange" size={16} />
                +91 9958260035
              </a>
              
            </div>
          </div>
        </div>

        {/* ============ BOTTOM BAR ============ */}
       
      </div>
    </footer>
  );
}
